import { Currency } from "components/CustomCurrency/currency";
import CompoundDetailButtom from "../components/CompoundDetailButtom";

function getTableData(molecularCompoundSummaryList, modalSetOpen, setSelectedCompoundForDetails) {
  // param: molecularCompoundSummaryList: lista the objetos tipo MolecularCompoundSummary
  var rows = [];
  molecularCompoundSummaryList.forEach((compound) => {
    var _temp = {
      Nro: compound.id,
      name: compound.molecularCompoundName,
      total: <Currency value={compound.total} />,
      quarter1: <Currency value={compound.quarterSales1} />,
      quarter2: <Currency value={compound.quarterSales2} />,
      quarter3: <Currency value={compound.quarterSales3} />,
      quarter4: <Currency value={compound.quarterSales4} />,
      ver: CompoundDetailButtom(
        compound.molecularCompoundName,
        modalSetOpen,
        setSelectedCompoundForDetails
      ),
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Compuesto Molecular", accessor: "name" },
      { Header: "Ventas Totales", accessor: "total", width: "10%" },
      { Header: "I Trimestre", accessor: "quarter1", width: "10%" },
      { Header: "II Trimestre", accessor: "quarter2", width: "10%" },
      { Header: "III Trimestre", accessor: "quarter3", width: "10%" },
      { Header: "IV Trimestre", accessor: "quarter4", width: "10%" },
      { Header: "Ver", accessor: "ver", width: "5%" },
    ],
    rows: rows,
  };
}

export default getTableData;
